import {observable, action, runInAction} from 'mobx'
import themeSettingAPI from '../apis/themeSettingAPI'
import alertMessage from '../utils/alertMessage'

export default class ThemeSettingStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false

  @action
  async onSaveAction(params) {
    this.isFetching = true
    try {
      const response = await themeSettingAPI.saveApi(params)
      const {code, messageEn} = response?.data
      runInAction(() => {
        this.isFetching = false;
        if (code === 0) {
          alertMessage.success('Save Success！')
          this.onSearchAction()
        }else {
          alertMessage.error('Save Error！' + messageEn +'')
        }
      })
    } catch (err) {
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

}
